<template>
  <div class="container">
    <search id="searchComponent" class="mb-4" @getFilter="getFilter"></search>

    <publicidad></publicidad>

    <div class="modal fade bd-example-modal-xl" id="setQuestion" tabindex="-1" role="dialog"
      aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header bg bg-primary text-white">
            <h5 class="modal-title" id="exampleModalLabel">Hacer pregunta</h5>
            <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group row">
              <label for="ALNUM_question" class="col-12 col-form-label">Comentario</label>
              <div class="col-md-12">
                <div class="row">
                  <div class="input-group col-11">
                    <textarea ref="text_question" rows="6" class="form-control cuenta_caracteres" id="ALNUM_question"
                      type="text" placeholder="Ingresa la pregunta" onkeyup="validar(this.form);cuenta_caracteres(this)"
                      name="question" autocomplete="details" v-model="question" maxlength="256">
                                    </textarea>
                  </div>
                  <span id="span_ALNUM_question" class="my-auto" aria-hidden="true"></span>
                </div>
                <div class="row justify-content-between">
                  <div class="col-11">
                    <div class="row no-gutters justify-content-between">
                      <div class="col-auto">
                        <div id="div_ALNUM_question" class="form-text text-danger"></div>
                      </div>
                      <div class="col-auto text-muted my-auto">Caracteres restantes: <i class="num_cuenta_carac">256</i>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <div class="col-12 pt-2">
                <button type="button" class="btn btn-primary" @click="saveQuestion()" data-dismiss="modal">
                  <i class="fas fa-save"></i>
                  Guardar pregunta
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade bd-example-modal-lg" id="exampleModal" tabindex="-1" role="dialog"
      aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header bg bg-primary text-white">
            <h5 class="modal-title" id="exampleModalLabel">Publicaciones similares:</h5>
            <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <h5 class="font-weight-bold">{{ post.title }}</h5>
            <modal-busqueda v-if="this.post.category_path" :post_seleccionado="this.post"></modal-busqueda>
          </div>

        </div>
      </div>
    </div>

    <div class="modal fade bd-datos_vendedor-modal-lg" id="datosVendedor" tabindex="-1" role="dialog"
      aria-labelledby="datosVendedorLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header bg bg-primary text-white">
            <h5 class="modal-title" id="datosVendedorLabel">Datos del vendedor:</h5>
            <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <div class="col-12 row "><label class="col-12 col-lg-3 text-lg-right font-weight-bold"><i class="fas fa-user pr-1"></i> Nombre:</label><div class="col-12 col-lg-9">{{this.nombre_real_usuario}}</div></div>
            <div class="col-12 row pt-2"><label class="col-12 col-lg-3 text-lg-right font-weight-bold"><i class="fas fa-phone pr-1"></i> Teléfono:</label><div class="col-12 col-lg-9">{{this.telefono_usuario}}</div></div>
            <div class="col-12 row pt-2"><label class="col-12 col-lg-3 text-lg-right font-weight-bold"><i class="fas fa-at pr-1"></i> Email:</label><div class="col-12 col-lg-9">{{this.correo_usuario}}</div></div>  
          </div>
          <whatsapp :celular=this.telefono_usuario :producto=post.title></whatsapp>
        </div>
      </div>
    </div>

    <div class="modal fade bd-example-modal-xl" id="enviarOferta" tabindex="-1" role="dialog"
      aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header bg bg-primary text-white">
            <h5 class="modal-title" id="exampleModalLabel">{{ post.title }} - {{ precio}}</h5>
            <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="alert alert-primary" role="alert">
              <i class="fas fa-exclamation-triangle pr-1"></i> El precio que ingreses como oferta es un estimado basado en lo que consideras razonable pagar por el vehículo. Sin embargo, el precio final de la compra dependerá de las condiciones del vehículo y del acuerdo que negocies con el vendedor.
            </div>
            <div class="form-group row">
              <label for="MAIG1_precio_oferta" 
                class="col-12 col-form-label">Precio<sup>&nbsp;(*)&nbsp;</sup>
              </label>
              <div class="col-md-12">
                <div class="row">
                  <div class="input-group col-11">
                    <input ref="precioActual" id="MAIG1_precio_oferta" v-model="offer_price" name="offer_price"
                      @keyup="validar" class="form-control w-25" />
                  </div>
                  <span id="span_MAIG1_precio_oferta" class="my-auto" aria-hidden="true"></span>
                </div>
                <div id="div_MAIG1_precio_oferta" class="form-text text-danger"></div>
                <div class="form-text text-danger"></div>
              </div>
            </div>
            <div class="form-group row">
              <label for="ALNUM_oferta" class="col-12 col-form-label">Detalle</label>
              <div class="col-md-12">
                <div class="row">
                  <div class="input-group col-11">
                    <textarea ref="text_oferta" rows="6" class="form-control cuenta_caracteres" id="ALNUM_oferta"
                      type="text" placeholder="Ingresa el detalle" onkeyup="validar(this.form);cuenta_caracteres(this)"
                      name="offer" autocomplete="offer" v-model="offer" maxlength="200">
                                    </textarea>
                  </div>
                  <span id="span_ALNUM_oferta" class="my-auto" aria-hidden="true"></span>
                </div>
                <div class="row justify-content-between">
                  <div class="col-11">
                    <div class="row no-gutters justify-content-between">
                      <div class="col-auto">
                        <div id="div_ALNUM_oferta" class="form-text text-danger"></div>
                      </div>
                      <div class="col-auto text-muted my-auto">Caracteres restantes: <i class="num_cuenta_carac">256</i>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <div class="col-12 pt-2">
                <button type="button" class="btn btn-primary" @click="saveOffer()" data-dismiss="modal">
                  <i class="far fa-envelope pr-1"></i>
                  Enviar oferta
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showModal" class="modal-padre" @click="closeModal">
      <!-- Icono para cerrar el modal -->
      <button class="close-modal-padre-button" @click.stop="closeModal">
        <span aria-hidden="true">&times;</span>
      </button>

      <img :src="imagesModal[currentIndex].src" class="modal-image" />

      <a class="carousel-control-prev" href="#product-modal" role="button">
        <span class="carousel-control-prev-icon icono-modal-prev" aria-hidden="true" @click.stop="prevImage"></span>
        <span class="sr-only">Previous</span>
      </a>

      <a class="carousel-control-next" href="#product-modal" role="button">
        <span class="carousel-control-next-icon icono-modal-next" aria-hidden="true" @click.stop="nextImage"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>

    <!-- Page Heading -->
    <div class="row">
      <div class="col-12">
        <h2 class="h6 border-bottom pb-3 mb-3 font-weight-bold">{{ post.category_path }}</h2>
        <h6 class="mb-0 text-sm"><i class="far fa-clock pr-1"></i> Publicado {{ this.fechaRelativa(post.created_at) }}</h6>
      </div>
    </div>
    <!-- /.row -->

            

    <div class="row">
      <div v-if="imagesLoaded" class="col-lg-6 mb-4">
        <div id="product-carousel" class="carousel slide p-2">
          <div class="carousel-inner border p-2 rounded" role="listbox">
            <div class="carousel-item active">
              <div class="custom-container" @mousemove="zoom($event, post, 0)" @mouseleave="resetZoom(post)">
                <img :src="'/post_images/' + post.id + '/' + post.image" class="zoom-image" ref="zoomImage-0"
                  @click="openModal(0); resetZoom(post)" />
                <div :ref="'zoomLens-0'" class="zoom-lens"></div>
                <div class="zoom-icon" v-show="isZooming"
                  style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); z-index: 10;">
                  <i class="fas fa-search-plus"></i> <!-- Icono de lupa de Font Awesome -->
                </div>
              </div>
            </div>
            <div v-for="(item, index) in images" :key="index" class="carousel-item">
              <div class="custom-container" @mousemove="zoom($event, item, index)" @mouseleave="resetZoom(item)">
                <img :src="'/post_images/' + post.id + '/' + item.image" class="zoom-image"
                  @click="openModal(index + 1); resetZoom(item)" />
                <div :ref="'zoomLens-' + (index + 1)" class="zoom-lens"></div>
                <div class="zoom-icon" v-show="isZooming"
                  style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); z-index: 10;">
                  <i class="fas fa-search-plus"></i> <!-- Icono de lupa de Font Awesome -->
                </div>
              </div>
            </div>
          </div>
          <!-- Mueve los controles fuera del contenedor que tiene la imagen -->
          <a class="carousel-control-prev" href="#product-carousel" role="button" data-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
          </a>
          <a class="carousel-control-next" href="#product-carousel" role="button" data-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
          </a>
        </div>

        <!-- Thumb Images -->
        <div class="col-sm-12 space mt-3">
          <a class="col-1 p-0" href="#"><img :data-image="1" style="width: 45px; height: 45px" class="img-thumbnail"
              :src="'/post_images/' + post.id + '/' + post.image" v-on:click="loadImage(1)" /></a>
          <a v-for="(item, index) in images" :key="index" class="col-1 p-0" href="#"><img
              style="width: 45px; height: 45px;" :data-image="index + 2" :class="'img-thumbnail'"
              :src="'/post_images/' + post.id + '/' + item.image" :alt="post.title" v-on:click="loadImage(index + 2)" />
          </a>
        </div>
      </div>

      <!-- INFORMACION PRODUCTO -->
      <div class="col-lg-6">
        <form class="form-horizontal" action="/cart/add/224300" method="post" enctype="multipart/form-data" name="buy">
            <div>
              <div class="mb-0 row justify-content-between">
                <span class="col-6 text-capitalize">{{ this.tipo_titulos + ' ' +state.title }}</span>
                <h5><span v-if="this.post.category_id == 'No mostrar por ahora'" class="col-md-4 col-6 align-self-end text-right d-inline px-2 mx-2 py-1 badge badge-info"><i class="fas fa-comment-dollar pr-1"></i> {{ this.offers.length == 0 ? 'Sin ofertas' : this.offers.length == 1 ? this.offers.length + ' Oferta' : this.offers.length + ' Ofertas' }}</span></h5>
              </div>
            </div>
          <h4 class="font-weight-bold">{{ post.title }}</h4>
          <h3 class="pb-1 mb-2 font-weight-bold text-price">{{ precio }}</h3>
          <div v-if="this.post.category_id != 100" class="rating-block mb-2">
            <div class="d-flex flex-row">
              <div v-for="i in this.avg" :key="i" class="ratings-good-nbg mr-1">
                <i class="fas fa-star"></i>
              </div>
              <div v-for="i in 5 - this.avg" :key="i + 10" class="ratings-empty mr-1">
                <i class="fas fa-star"></i>
              </div>
              <span class="d-flex align-items-center ml-2">({{ this.total_califications === undefined ? 0 :
      this.total_califications }})</span>
            </div>
          </div>
          <div class="row">
            <!-- STOCK -->
            <div class="col-12 col-lg-6 d-flex align-items-center justify-content-left mb-2">
              <div class="p-2 border d-flex rounded border-secondary align-items-center justify-content-center" style="max-height: 35px;">
                <i class="fa fa-boxes fa-fw"></i>
              </div>
              <div class="d-flex align-items-left justify-content-center flex-column pl-2 text-truncate">
                <h6 class="p-0 m-0 text-truncate font-weight-bold">Stock disponible</h6>
                <span class="p-0 m-0 text-truncate">{{ post.stock }} {{ post.stock == 1 ? 'unidad' : 'unidades'
                  }}</span>
              </div>
            </div>
            <!-- METODO DE ENTREGA -->
            <div v-if="post.category_id != 100" class="col-12 col-lg-6 d-flex align-items-center justify-content-left mb-2">
              <div class="p-2 border d-flex rounded border-secondary align-items-center justify-content-center" style="max-height: 35px;">
                <i class="fa fa-shuttle-van fa-fw"></i>
              </div>
              <div class="d-flex align-items-left justify-content-center flex-column pl-2 text-truncate">
                <h6 class="p-0 m-0 text-truncate font-weight-bold">Método de entrega</h6>
                <span class="p-0 m-0 text-truncate">Acordar con el comprador</span>
              </div>
            </div>
            <!-- Año-->
            <div v-else class="col-12 col-lg-6 d-flex align-items-center justify-content-left mb-2">
              <div class="p-2 border d-flex rounded border-secondary align-items-center justify-content-center" style="max-height: 35px;">
                <i class="fa fa-calendar fa-fw"></i>
              </div>
              <div class="d-flex align-items-left justify-content-center flex-column pl-2 text-truncate">
                <h6 class="p-0 m-0 text-truncate font-weight-bold">Año</h6>
                <span class="p-0 m-0 text-truncate">{{ post.anio }} </span>
              </div>
            </div>
            <!-- COLOR -->
            <div
              v-bind:class="[this.colors.toString().length > 20 ? 'col-12 col-lg-12 col-xl-6 d-flex align-items-top justify-content-left mb-2' : 'col-12 col-lg-6 d-flex align-items-top justify-content-left mb-2']">
              <div class="p-2 border d-flex rounded border-secondary align-items-center justify-content-center"
                style="max-height: 35px;">
                <i class="fa fa-tint fa-fw"></i>
              </div>
              <div class="d-flex align-items-left justify-content-top flex-column pl-2">
                <h6 class="p-0 m-0 text-truncate font-weight-bold">Color(es) disponible(s)</h6>
                <span class="p-0 m-0">{{ post.colors }}</span>
              </div>
            </div>
            <!-- ZONA DE ENTREGA -->
            <div  v-if="post.category_id != 100"
              v-bind:class="[this.zonas_entrega.toString().length > 20 ? 'col-12 col-lg-12 col-xl-6 d-flex align-items-top justify-content-left mb-2' : 'col-12 col-lg-6 d-flex align-items-top justify-content-left mb-2']">
              <div class="p-2 border d-flex rounded border-secondary align-items-center justify-content-center"
                style="max-height: 35px;">
                <i class="fa fa-map fa-fw"></i>
              </div>
              <div class="d-flex align-items-left justify-content-top flex-column pl-2">
                <h6 class="p-0 m-0 text-truncate font-weight-bold">Zonas de entrega</h6>
                <span class="p-0 m-0">{{ this.zonas_entrega }}</span>
              </div>
            </div>            
            <!-- Kilometraje -->
            <div v-else class="col-12 col-lg-6 d-flex align-items-center justify-content-left mb-2">
              <div class="p-2 border d-flex rounded border-secondary align-items-center justify-content-center" style="max-height: 35px;">
                <i class="fa fa-tachometer-alt fa-fw"></i>
              </div>
              <div class="d-flex align-items-left justify-content-center flex-column pl-2 text-truncate">
                <h6 class="p-0 m-0 text-truncate font-weight-bold">Kilometraje</h6>
                <span class="p-0 m-0 text-truncate">{{ post.kilometraje.toLocaleString("es-CL", {
            currency: "CLP",
          }) }} kms. </span>
              </div>
            </div>
            <div v-if="post.category_id == 100" class="col-12 col-lg-6 d-flex align-items-center justify-content-left mb-2">
                <div class="p-2 border d-flex rounded border-secondary align-items-center justify-content-center" style="max-height: 35px;">
                  <i class="fa fa-map-marker-alt fa-fw"></i>
                </div>
                <div class="d-flex align-items-left justify-content-center flex-column pl-2 text-truncate">
                  <h6 class="p-0 m-0 text-truncate font-weight-bold">Ubicación</h6>
                  <span class="p-0 m-0 text-truncate">{{ post.commune}} - {{ post.sector }}</span>
                </div>
              </div>
          </div>

          <div v-if="this.post.category_id != 100 ">
            <div v-if="user == 2" class="row">
              <div class="col-12 col-lg-6 d-flex align-items-center justify-content-left mb-2">
                <button v-if="this.usuario.ban_buy == 0 && this.usuario.id != this.post.user_id" type="button"
                  class="btn btn-primary w-auto font-weight-bold text-no-wrap" data-toggle="modal"
                  data-target="#exampleModal">
                  Hacer Match / Comprar
                </button>
                <button v-else type="button" class="btn btn-danger text-nowrap font-weight-bold" disabled>
                  Bloqueado para hacer match
                </button>
                <a :href="this.dominio" target="_blank" class="m-2" data-toggle="tooltip" data-placement="top"
                  title="Manual de usuario">
                  <i class="fas fa-question-circle align-middle fa-lg"></i>
                </a>
              </div>
              <div class="col-12 col-lg-6 d-flex align-items-center justify-content-left mb-2">
                <button v-if="this.usuario.id != this.post.user_id" type="button"
                  class="btn btn-primary w-auto font-weight-bold px-4 d-none d-md-block" data-toggle="modal"
                  data-target="#setQuestion" @click="limpiarPregunta">
                  Preguntar al vendedor
                </button>
                <button v-else type="button" class="btn btn-danger w-auto font-weight-bold px-4 d-none d-md-block"
                  disabled>
                  Preguntar al vendedor
                </button>
                <button v-if="this.usuario.id != this.post.user_id" type="button"
                  class="btn btn-primary w-auto font-weight-bold px-4 d-md-none mt-2" data-toggle="modal"
                  data-target="#setQuestion" @click="limpiarPregunta">
                  Preguntar al vendedor
                </button>
                <button v-else type="button" class="btn btn-danger w-auto font-weight-bold px-4 d-md-none mt-2" disabled>
                  Preguntar al vendedor
                </button>
              </div>
            </div>

            <div v-else class="row">
              <div class="col-12 col-lg-6 d-flex align-items-center justify-content-left mb-2">
                <button class="btn btn-primary w-auto font-weight-bold" type="button" @click="cargarLogin('match')">
                  Hacer Match / Comprar
                </button>
                <a :href="this.dominio" target="_blank" class="m-2" data-toggle="tooltip" data-placement="top"
                  title="Manual de usuario">
                  <i class="fas fa-question-circle align-middle fa-lg"></i>
                </a>
              </div>
              <div class="col-12 col-lg-6 d-flex align-items-center justify-content-left mb-2">
                <button class="btn btn-primary w-auto font-weight-bold px-4" type="button"
                  @click="cargarLogin('pregunta')">
                  Preguntar al vendedor
                </button>

              </div>
            </div>
          </div>          

          <!-- Vehículos -->
          <div v-else>
            <div v-if="user == 2" class="row">
              <div v-if="(post.conversable != 1 || post.accepted) && this.usuario.id != this.post.user_id" class="col-12 col-lg-6 d-flex align-items-center justify-content-left mb-2">
                <button type="button"
                  class="btn btn-primary w-100 font-weight-bold text-no-wrap" data-toggle="modal"
                  data-target="#datosVendedor">
                  Ver datos del vendedor
                </button>
              </div>
              <div v-else-if="(post.conversable != 1 || post.accepted)  && this.usuario.id == this.post.user_id" class="col-12 col-lg-6 d-flex align-items-center justify-content-left mb-2">
                <button type="button" disabled
                  class="btn btn-danger font-weight-bold text-no-wrap">
                  Ver datos del vendedor
                </button>
              </div>


              <div v-if="(post.conversable == 1 && !post.accepted) && this.usuario.id != this.post.user_id" class="col-12 col-lg-6 d-flex align-items-center justify-content-left mb-2">
                <button type="button"
                  class="btn btn-primary w-100 font-weight-bold text-no-wrap btn-block" data-toggle="modal"
                  data-target="#enviarOferta">
                  Realizar oferta
                </button>
              </div>
              <div v-else-if="(post.conversable == 1 && !post.accepted)  && this.usuario.id == this.post.user_id" class="col-12 col-lg-6 d-flex align-items-center justify-content-left mb-2">
                <button type="button" disabled
                  class="btn btn-danger w-100 font-weight-bold text-no-wrap btn-block">
                  Realizar oferta
                </button>
              </div>
              <div class="col-12 col-lg-6 d-flex align-items-center justify-content-left mb-2">
                <button v-if="this.usuario.id != this.post.user_id" type="button"
                  class="btn btn-primary w-100 font-weight-bold px-4 d-none d-md-block" data-toggle="modal"
                  data-target="#setQuestion" @click="limpiarPregunta">
                  Preguntar al vendedor
                </button>
                <button v-else type="button" class="btn btn-danger w-auto font-weight-bold px-4 d-none d-md-block"
                  disabled>
                  Preguntar al vendedor
                </button>
                <button v-if="this.usuario.id != this.post.user_id" type="button"
                  class="btn btn-primary w-100 font-weight-bold px-4 d-md-none mt-2" data-toggle="modal"
                  data-target="#setQuestion" @click="limpiarPregunta">
                  Preguntar al vendedor
                </button>
                <button v-else type="button" class="btn btn-danger w-100 font-weight-bold px-4 d-md-none mt-2" disabled>
                  Preguntar al vendedor
                </button>
              </div>
            </div>

            <div v-else class="row">
              <div v-if="post.conversable != 1" class="col-12 col-lg-6 d-flex align-items-center justify-content-left mb-2">
                <button class="btn btn-primary w-100 font-weight-bold" type="button" @click="cargarLogin('usuario')">
                  Ver datos vendedor
                </button>
              </div>
              <div v-else class="col-12 col-lg-6 d-flex align-items-center justify-content-left mb-2">
                <button class="btn btn-primary w-100 font-weight-bold btn-block" type="button" @click="cargarLogin('oferta')">
                  Realizar oferta
                </button>
              </div>
              <div class="col-12 col-lg-6 d-flex align-items-center justify-content-left mb-2">
                <button class="btn btn-primary w-100 font-weight-bold px-4" type="button"
                  @click="cargarLogin('pregunta')">
                  Preguntar al vendedor
                </button>

              </div>
            </div>
          </div>    
        </form>
      </div>

      <div class="container">
        <hr class="my-4">
        <div class="row">
          <div class="col-12 col-lg-7 col-md-12 h6">
            <h3 class=" font-weight-bold pb-3">Características del {{ this.tipo_titulos }}</h3>
            <table class="table table-hover table-striped">
              <tbody>
                <tr v-for="(fila, index) in filasAtributos" :key="index">
                  <td class="ml-3 font-weight-bold">{{ fila[0].label }}</td>
                  <td>{{ fila[0].value }}</td>
                  <template v-if="fila[1]">
                    <td class="border-left ml-3 font-weight-bold">{{ fila[1].label }}</td>
                    <td class="text-justify">{{ fila[1].value }}</td>
                  </template>
                  <template v-else>
                    <td colspan="2"></td> <!-- Rellenar con espacio vacío si solo hay un atributo -->
                  </template>
                </tr>
              </tbody>
            </table>

            <div v-if="post.category_id == 100" class="font-italic">* Las especificaciones del vehículo han sido indicadas por el vendedor, por favor, confirma con él los detalles.</div>
          </div>

          <!-- CALIFICACION DEL VENDEDOR -->
          <div class="col-12 col-lg-5 col-md-12 h6">
            
            <h3 class="font-weight-bold pb-3">Calificación del vendedor</h3>
            <div class="row">
              <div class="col-12 font-weight-bold">{{ this.nombre_usuario }}</div>
              <div class="col-12 d-flex align-items-center justify-content-left px-3 pt-3">
                <div class="d-flex align-items-center justify-content-center pr-3">
                  <i
                    v-bind:class="[this.rating_ventas == 0 ? 'fa fa-3x fa-meh-blank text-secondary' : (this.rating_ventas == 3 ? 'fa fa-3x fa-meh text-secondary' : (this.rating_ventas < 3 ? 'fa fa-3x fa-frown text-warning' : (this.rating_ventas > 3 ? 'fa fa-3x fa-smile text-success' : null)))]"></i>
                </div>
                <div class="d-flex align-items-left justify-content-center flex-column">
                  <span class="">{{ this.ventas_reales == 0 ? 'Sin ventas' : (this.ventas_reales == 1 ? '1 venta' :
      `${this.ventas_reales} ventas`) }}</span>
                  <div class="rating-block p-0">
                    <div class="d-flex flex-row">
                      <div v-for="i in this.rating_ventas " :key="i" class="ratings-good-nbg mr-1">
                        <i class="fas fa-star fa-2x"></i>
                      </div>
                      <div v-for="i in 5 - this.rating_ventas " :key="i + 10" class="ratings-empty mr-1">
                        <i class="fas fa-star fa-2x"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- DETALLE DE CALIFICACIONES-->
              <div v-if="isVisible" class="col-12">
                <div class="float-left col-12" v-for="(desgloce, index) in  post.ratings.desgloce_all" :key="index">
                  <div class="float-left">
                    <div style="height:9px; margin:5px 0;">{{ 6 - index }} <i class="fas fa-star"></i></div>
                  </div>
                  <div class="float-left" style="width:180px;">
                    <div class="progress" style="height:9px; margin:8px 0;">
                      <div :class="'progress-bar ' + desgloce.class" role="progressbar" aria-valuenow="5"
                        aria-valuemin="0" aria-valuemax="5" :style="'width:' + desgloce.porcentaje + '%'">
                        <span class="sr-only">{{ desgloce.porcentaje + '% Complete (danger)' }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="float-right" style="margin-left:10px;">{{ desgloce.valor }}</div>
                </div>
              </div>
            </div>
            <!-- COMENTARIOS TOTALES-->
            <div v-if="isVisible" class="from-group row mt-3">
              <div class="col-12" v-for="(rating, index) in this.detalle_all" :key="index">
                <div class="row">
                  <div class="col-12">
                    <div class="review-block rounded">
                      <div class="row">
                        <div class="col-sm-3">
                          <div class="review-block-name"><i :class="rating.class_icono"></i></div>
                          <div class="review-block-name">{{ rating.user_name }}</div>
                          <div class="review-block-date">({{ rating.commune }})</div>
                        </div>
                        <div class="col-sm-6">
                          <div class="review-block-rate">
                            <div class="review-block-date pb-1 font-weight-bold">{{ rating.title }}</div>
                            <div class="d-flex flex-row">
                              <div v-for="i in rating.qualification" :key="i" class="ratings-good-nbg mr-1">
                                <i class="fas fa-star"></i>
                              </div>
                              <div v-for="i in 5 - rating.qualification" :key="i + 10" class="ratings-empty mr-1">
                                <i class="fas fa-star"></i>
                              </div>
                            </div>
                            <div class="review-block-date">{{ rating.razon_calificacion }}</div>
                            <div class="review-block-description pt-1">{{ rating.obs }}</div>
                          </div>
                        </div>
                        <div class="col-sm-3">
                          <div class="review-block-date text-right">{{ rating.fecha_dia + ' ' + rating.fecha_mes + ' ' +
      rating.fecha_ano }}<br /></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <button type="button" class="btn btn-outline-primary w-100 btn-block mt-3" @click="toggleCalification">{{
      this.textCalification }}</button>
          </div>


        </div>
      </div>

      <div class="container">
        <hr class="my-4">
        <div class="row">
          <!-- DESCRIPCION -->
          <div class="col-12 col-lg-6">
            <div class="form-group row">
              <h3 class="col-12 font-weight-bold pb-3">Descripción del {{ this.tipo_titulos }}</h3>
              <div class="col-12 h5 text-justify font-weight-light">
                <p style="white-space: pre-line;">{{ post.content }}</p>
              </div>
            </div>
          </div>

          <!-- COMENTARIOS:CALIFICACION -->
          <div class="col-12 col-lg-6" v-if="this.total_califications > 0">
            <hr class="my-4">
            <div class="from-group row">
              <h3 class="col-12 font-weight-bold pb-3">Comentarios del {{ this.tipo_titulos }}</h3>
              <div class="col-12 mb-2">
                <div class="d-flex justify-content-left align-items-center">
                  <span class="pr-3 font-weight-bold display-4">
                    {{ this.avg }}
                  </span>
                  <div class="d-flex justify-content-center align-items-left flex-column">
                    <span>{{ post.ratings.total_califications }} {{ post.ratings.total_califications == 1 ?
      'Calificación'
      : 'Calificaciones' }}</span>
                    <div class="rating-block p-0">
                      <div class="d-flex flex-row">
                        <div v-for="i in this.avg" :key="i" class="ratings-good-nbg mr-1">
                          <i class="fas fa-star fa-2x"></i>
                        </div>
                        <div v-for="i in 5 - this.avg" :key="i + 10" class="ratings-empty mr-1">
                          <i class="fas fa-star fa-2x"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="float-left col-12" v-for="(desgloce, index) in  post.ratings.desgloce" :key="index">
                  <div class="float-left">
                    <div style="height:9px; margin:5px 0;">{{ 6 - index }} <i class="fas fa-star"></i></div>
                  </div>
                  <div class="float-left" style="width:180px;">
                    <div class="progress" style="height:9px; margin:8px 0;">
                      <div :class="'progress-bar ' + desgloce.class" role="progressbar" aria-valuenow="5"
                        aria-valuemin="0" aria-valuemax="5" :style="'width:' + desgloce.porcentaje + '%'">
                        <span class="sr-only">{{ desgloce.porcentaje + '% Complete (danger)' }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="float-right" style="margin-left:10px;">{{ desgloce.valor }}</div>
                </div>
              </div>
            </div>
            <!-- COMENTARIOS -->
            <div class="from-group row mt-3">
              <div class="col-12" v-for="(rating, index) in this.detalle" :key="index">
                <div class="row">
                  <div class="col-12">
                    <div class="review-block rounded">
                      <div class="row">
                        <div class="col-sm-3">
                          <div class="review-block-name"><i :class="rating.class_icono"></i></div>
                          <div class="review-block-name">{{ rating.user_name }}</div>
                        </div>
                        <div class="col-sm-6">
                          <div class="review-block-rate">
                            <div class="d-flex flex-row">
                              <div v-for="i in rating.qualification" :key="i" class="ratings-good-nbg mr-1">
                                <i class="fas fa-star"></i>
                              </div>
                              <div v-for="i in 5 - rating.qualification" :key="i + 10" class="ratings-empty mr-1">
                                <i class="fas fa-star"></i>
                              </div>
                            </div>
                            <div class="review-block-date">{{ rating.razon_calificacion }}</div>
                            <div class="review-block-description">{{ rating.obs }}</div>
                          </div>
                        </div>
                        <div class="col-sm-3">
                          <div class="review-block-date text-right">{{ rating.fecha_dia + ' ' + rating.fecha_mes + ' ' +
      rating.fecha_ano }}<br /><!-- {{ rating.fecha_diferencia }} --></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Productos vendedor -->
      <div class="col-12 p-0">
        <posts-related v-if="this.post" :id="'opv'" :title="this.titulo_otros_usuario" :user_p="1"
          :slug_p="this.post.slug" :idp="this.post.user_id"></posts-related>
      </div>

      <!-- Productos relacionados -->
      <div class="col-12 p-0">
        <posts-related v-if="this.post" :id="'opr'" :title="this.titulo_otros_relacionados" :user_p="0"
          :slug_p="this.post.slug"></posts-related>
      </div>

      <div v-if="this.questions.length > 0" class="col-12">
        <hr>
        <div class="form-group row">
          <h3 class="col-12 font-weight-bold pb-1">Preguntas</h3>
          <div class="col-12 mb-2">
            <div class="form-group row h5 text-justify font-weight-light" v-for="(item, index) in questions"
              :key="index">
              <div class="col-12 pb-2"><i class="fas fa-question-circle text-primary"></i> {{item.question}}</div>
              <div class="col-12 text-muted text-justify pb-3">
                <i class="fas fa-comment-alt text-primary pl-3"></i>
                {{item.answer}}
                <small class="text-italic">{{item.updated_at}}</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>
<script>

import SearchComponentVue from "./SearchComponent.vue";
import { formatDistanceToNow } from 'date-fns';
import { es } from 'date-fns/locale'; // Importa el idioma si no quieres que sea en inglés

export default {
  components: {
    SearchComponentVue
  },
  props: ['usuario'],

  imageSrc: {
    type: String,
    required: true,
  },
  mounted() {
    this.getPost();
    $('[data-toggle="tooltip"]').tooltip();
    this.baseUrl = process.env.MIX_PUSHER_APP_URL;
    this.handleResize(); // Llamar a handleResize para configurar correctamente los chunks al montar el componente
    window.addEventListener('resize', this.handleResize);
  },
  computed: {
    filasAtributos() {
      // Dividir el arreglo en filas de 2 elementos cada una
      if (this.post.category_id != 100) this.chunks = 1;
      
      const filas = [];
      for (let i = 0; i < this.atributos.length; i += this.chunks) {
        filas.push(this.atributos.slice(i, i + this.chunks));
      }
      return filas;
    },
  },
  methods: {
    getPost: function () {
      fetch("/api/post/" + this.$route.params.slug)
        .then((response) => {
          if (!response.ok) {
            // Si la respuesta no está OK, lanzar un error
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.json();
        })
        .then((json) => {
          // Manejar los datos exitosos aquí
          this.post = json.data;
          this.state = this.post.state;
          this.images = this.post.images;
          this.questions = this.post.questions;
          this.precio = this.post.maxprice.toLocaleString("es-CL", {
            style: "currency",
            currency: "CLP",
          });
          this.zonas_entrega = this.post.rating_user.zonas_entrega;
          this.ventas_reales = this.post.rating_user.ventas_reales;
          this.nombre_usuario = this.post.rating_user.nombre_usuario;
          this.nombre_real_usuario = this.post.rating_user.nombre_real_usuario;
          this.telefono_usuario = this.post.rating_user.telefono_usuario;
          this.correo_usuario = this.post.rating_user.email_usuario;
          this.rating_ventas = this.post.rating_user.rating_ventas;
          this.total_califications = this.post.ratings.total_califications;
          this.detalle = this.post.ratings.detalle;
          this.detalle_all = this.post.ratings.detalle_all;
          this.avg = this.post.ratings.avg;
          this.colors = this.post.colors;

          this.titulo_otros_usuario = this.post.category_id == 100 ? 'Otros vehículos del vendedor' : 'Otros productos del vendedor';
          this.titulo_otros_relacionados = this.post.category_id == 100 ? 'Otros vehículos relacionados' : 'Otros productos relacionados';
          this.tipo_titulos = this.post.category_id == 100 ? 'vehículo' : 'producto';

          this.imagesModal = [
            { src: '/post_images/' + this.post.id + '/' + this.post.image }, // Imagen principal
            ...(Array.isArray(this.images) && this.images.length > 0
              ? this.images.map(item => ({ src: '/post_images/' + this.post.id + '/' + item.image }))
              : [])
          ];

              if (this.post.marca)              this.atributos.push({ label: "Marca", value: this.post.marca });
              if (this.post.modelo)             this.atributos.push({ label: "Modelo", value: this.post.modelo });
              if (this.post.ancho)              this.atributos.push({ label: "Ancho", value: this.post.ancho.name });
              if (this.post.artista)            this.atributos.push({ label: "Artista", value: this.post.artista.name });
              if (this.post.formato)            this.atributos.push({ label: "Formato", value: this.post.formato.name });
              if (this.post.idioma)             this.atributos.push({ label: "Idioma", value: this.post.idioma.name });
              if (this.post.altura)             this.atributos.push({ label: "Altura", value: this.post.altura.name });
              if (this.post.aroBicicleta)       this.atributos.push({ label: "Aro", value: this.post.aroBicicleta.name });
              if (this.post.genero)             this.atributos.push({ label: "Género", value: this.post.genero.name });
              if (this.post.sexo)               this.atributos.push({ label: "Sexo", value: this.post.sexo.name });
              if (this.post.materialJoya)       this.atributos.push({ label: "Material", value: this.post.materialJoya.name });
              if (this.post.raza)               this.atributos.push({ label: "Raza", value: this.post.raza.name });
              if (this.post.titulo)             this.atributos.push({ label: "Título", value: this.post.titulo.name });
              if (this.post.evento)             this.atributos.push({ label: "Evento", value: this.post.evento.name });
              if (this.post.localidad)          this.atributos.push({ label: "Localidad", value: this.post.localidad.name });
              if (this.post.cantidadNeumaticos) this.atributos.push({ label: "Cantidad de Neumáticos", value: this.post.cantidadNeumaticos.name });
              if (this.post.cortaCorriente)     this.atributos.push({ label: "Tiene corta corriente", value: this.post.cortaCorriente.name });
              if (this.post.diametro)           this.atributos.push({ label: "Diámetro", value: this.post.diametro.name });
              if (this.post.edad)               this.atributos.push({ label: "Edad", value: this.post.edad.name });
              if (this.post.estilo)             this.atributos.push({ label: "Estilo", value: this.post.estilo.name });
              if (this.post.indiceCarga)        this.atributos.push({ label: "Índice de carga", value: this.post.indiceCarga.name });
              if (this.post.indiceVelocidad)    this.atributos.push({ label: "Índice de velocidad", value: this.post.indiceVelocidad.name });
              if (this.post.lado)               this.atributos.push({ label: "Cantidad de lados", value: this.post.lado.name });
              if (this.post.largo)              this.atributos.push({ label: "Lado", value: this.post.largo.name });
              if (this.post.material)           this.atributos.push({ label: "Material", value: this.post.material.name });
              if (this.post.materialExterior)   this.atributos.push({ label: "Material exterior", value: this.post.materialExterior.name });
              if (this.post.materialInterior)   this.atributos.push({ label: "Material interior", value: this.post.materialInterior.name });
              if (this.post.posicion)           this.atributos.push({ label: "Posición", value: this.post.posicion.name });
              if (this.post.sirena)             this.atributos.push({ label: "Sirena", value: this.post.sirena.name });
              if (this.post.sensorPresencia)    this.atributos.push({ label: "Sensor presencial", value: this.post.sensorPresencia.name });
              if (this.post.tamano)             this.atributos.push({ label: "Tamaño", value: this.post.tamano.name });
              if (this.post.tallaBebe)          this.atributos.push({ label: "Talla", value: this.post.tallaBebe.name });
              if (this.post.tallaCalzado)       this.atributos.push({ label: "Talla", value: this.post.tallaCalzado.name });
              if (this.post.tallaRopa)          this.atributos.push({ label: "Talla", value: this.post.tallaRopa.name });
              if (this.post.tamanoPantalla)     this.atributos.push({ label: "Tamaño de pantalla", value: this.post.tamanoPantalla.name });
              if (this.post.tipoCasco)          this.atributos.push({ label: "Tipo de casco", value: this.post.tipoCasco.name });
              if (this.post.tipoMontaje)        this.atributos.push({ label: "Tipo montaje", value: this.post.tipoMontaje.name });
              if (this.post.transductor)        this.atributos.push({ label: "Transductor", value: this.post.transductor.name });
              if (this.post.unidadPorEnvase)    this.atributos.push({ label: "Unidad por envase", value: this.post.unidadPorEnvase.name });
              if (this.post.voltaje)            this.atributos.push({ label: "Voltaje", value: this.post.voltaje.name });
              if (this.post.volumen)            this.atributos.push({ label: "Volumen", value: this.post.volumen.name });
              // Vehículos  
              if (this.post.version)            this.atributos.push({ label: "Versión", value: this.post.version });
              if (this.post.cilindrada)         this.atributos.push({ label: "Cilindrada", value: this.post.cilindrada.name });
              if (this.post.transmision)        this.atributos.push({ label: "Transmisión", value: this.post.transmision.name });
              if (this.post.combustible)        this.atributos.push({ label: "Combustible", value: this.post.combustible.name });
              if (this.post.traccion)           this.atributos.push({ label: "Tracción", value: this.post.traccion.name });
              if (this.post.motor)              this.atributos.push({ label: "Motor", value: this.post.motor.name });
              if (this.post.airbag)             this.atributos.push({ label: "Airbag", value: this.post.airbag.name });
              if (this.post.numero_puerta)      this.atributos.push({ label: "Número puertas", value: this.post.numero_puerta.name });
              if (this.post.motor_moto)         this.atributos.push({ label: "Motor", value: this.post.motor_moto.name });
              if (this.post.potencia_moto)      this.atributos.push({ label: "Potencia", value: this.post.potencia_moto.toLocaleString("es-CL", {
            currency: "CLP",
          }) + ' (hp)' });
              if (this.post.peso_moto)          this.atributos.push({ label: "Peso", value: this.post.peso_moto.toLocaleString("es-CL", {
            currency: "CLP",
          }) + ' (kg)' });
          if (this.post.capacidad_personas)   this.atributos.push({ label: "Capacidad personas", value: this.post.capacidad_personas });
          if (this.post.numero_pisos)         this.atributos.push({ label: "Número pisos", value: this.post.numero_pisos });
          if (this.post.garantia_vehiculo_id) this.atributos.push({label: 'Ofrece garantía', value: this.post.garantia_vehiculo_id == 1 ? 'Sin garantía' : this.post.detalle_garantia_vehiculo });
          if (this.post.financiamiento) this.atributos.push({label: 'Ofrece financiamiento', value: this.post.financiamiento == 1 ? 'Sí' : 'Sin financiamiento' });
          
          if (this.post.category_id == 100 && !localStorage.filtro){
            this.getOffers();
            localStorage.filtro = 'Categoria_id: 100';
            this.offer_price = '';
          }
          
        })
        .catch((error) => {
          // Capturar errores, incluyendo errores 404
          console.error(error);

          // Redirigir a la página de error o manejar de alguna otra manera
          // Puedes usar vue-router para la redirección, si estás usando Vue.js
          //this.$router.push('/pagina-de-error');
          //this.$router.go();
        })
        .finally(() => {
          setTimeout(() => {
            this.imagesLoaded = true;
            window.scrollTo(0, 0);
          }, 2000);
        });
    },
    loadImage: function (id_carousel) {
      $("#product-carousel").carousel(parseInt(id_carousel) - 1)
    },
    cargarLogin: function (buttonType) {
      let title, text, icon;
      if (buttonType === 'match') {
        title = 'Para comenzar una oferta, debes iniciar sesión';
        text = 'Si no eres usuario, por favor regístrate';
        icon = 'error';
      } else if (buttonType === 'pregunta') {
        title = 'Para hacer una pregunta, debes iniciar sesión';
        text = 'Si no eres usuario, por favor regístrate';
        icon = 'error';
      } else if (buttonType === 'usuario') {
        title = 'Para ver los datos del vendedor, debes iniciar sesión';
        text = 'Si no eres usuario, por favor regístrate';
        icon = 'error';
      } else if (buttonType === 'oferta') {
        title = 'Para poder enviar una oferta al vendedor, debes iniciar sesión';
        text = 'Si no eres usuario, por favor regístrate';
        icon = 'error';
      }
      this.$swal.fire({
        text: text,
        title: title,
        icon: icon,
        confirmButtonColor: '#3490dc',
        confirmButtonText: 'Aceptar'
      })
        .then((result) => {
          if (result.isConfirmed) {
            const currentUrl = window.location.pathname;
            this.$router.push({ path: '/login', query: { redirect: currentUrl } });
            this.$router.go()
          }
        });
    },
    getFilter(data) {
      if (data == '') {
        data = 'Titulo: ';
      }
      let data_url = 'find';
      fetch("/api/post_filter/" + data_url + "/?page=" + this.currentPage + "&filtro=" + data + '&orden=' + this.orden)
        .then((response) => response.json())
        .then((json) => {
          this.posts = json.data.data;
          this.total = json.data.last_page;
        });
    },
    limpiarPregunta() {
      this.$refs.text_question.value = '';
      cuenta_caracteres(this.$refs.text_question);
    },
    limpiarOferta() {
      this.$refs.text_oferta.value = '';
      cuenta_caracteres(this.$refs.text_oferta);
    },
    saveQuestion() {
      axios.post('/api/questionsPost/store', { //estas variables son las que enviaremos para que crear la tarea
        'id': this.post.id,
        'question': this.question,
        'id_puja': this.$route.params.id
      }
      ).then((response) => {
        //console.log(response);
        if (response.data.msj == 'pregunta_creada') {

          this.id_puja = response.data.data;
          //console.log(this.id_puja);
          this.$swal.fire({
            text: 'la pregunta será enviada al vendedor.',
            title: 'Se ha ingresado la pregunta correctamente',
            icon: 'success',
            confirmButtonColor: '#3490dc',
            confirmButtonText: 'Aceptar',
          });

        }
      })
        .catch((response) => {
          this.$swal.fire({
            text: 'Por favor, trata de ingresarla nuevamente',
            title: 'No se ha podido ingresar la pregunta',
            icon: 'error',
            confirmButtonColor: '#3490dc',
            confirmButtonText: 'Aceptar',
          });
        });
    },
    saveOffer() {
      axios.post('/api/offersPost/store', { //estas variables son las que enviaremos para que crear la tarea
        'id': this.post.id,
        'offer': this.offer,
        'offer_price': this.offer_price
      }
      ).then((response) => {
        //console.log(response);
        if (response.data.msj == 'oferta_creada') {

          this.$swal.fire({
            text: 'la oferta será enviada al vendedor.',
            title: 'Se ha ingresado la oferta correctamente',
            icon: 'success',
            confirmButtonColor: '#3490dc',
            confirmButtonText: 'Aceptar',
          });

        }
      })
        .catch((response) => {
          this.$swal.fire({
            text: 'Por favor, trata de ingresarla nuevamente',
            title: 'No se ha podido enviar la oferta',
            icon: 'error',
            confirmButtonColor: '#3490dc',
            confirmButtonText: 'Aceptar',
          });
        });
    },
    toggleCalification() {
      if (!this.isVisible) {
        this.scrollPosition = window.scrollY;
      }
      else {
        // Volver a la posición guardada del scroll al ocultar el contenido
        this.$nextTick(() => {
          window.scrollTo({ top: this.scrollPosition, behavior: 'smooth' });
        });
      }

      this.isVisible = !this.isVisible; // Alterna el estado
      this.textCalification = this.isVisible ? 'Ocultar todas las calificaciones' : 'Ver todas las calificaciones';
    },
    zoom(event, item, index) {
      this.isZooming = true;
      document.body.style.cursor = "zoom-in";
      const imgSrc = '/post_images/' + this.post.id + '/' + item.image;
      // Ahora puedes realizar el cálculo de zoom con la imagen correspondiente
      const image = this.$el.querySelector(`img[src="${imgSrc}"]`);
      const rect = image.getBoundingClientRect();
      const posX = event.clientX - rect.left;
      const posY = event.clientY - rect.top;

      // Ajustar el origen del zoom de la imagen
      image.style.transformOrigin = `${(posX / rect.width) * 100}% ${(posY / rect.height) * 100}%`;
      image.style.transform = 'scale(3)'; // Ajusta el nivel de zoom según lo que desees

    },
    resetZoom(item) {
      this.isZooming = false;
      document.body.style.cursor = "default";
      const imgSrc = '/post_images/' + this.post.id + '/' + item.image;
      // Ahora puedes realizar el cálculo de zoom con la imagen correspondiente
      const image = this.$el.querySelector(`img[src="${imgSrc}"]`);
      image.style.transform = 'scale(1)'; // Restablece la imagen a su tamaño original
    },
    openModal(index) {
      this.currentIndex = index;
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    prevImage() {
      this.currentIndex = (this.currentIndex - 1 + this.imagesModal.length) % this.imagesModal.length;
    },
    nextImage() {
      this.currentIndex = (this.currentIndex + 1) % this.imagesModal.length;
    },
    fechaRelativa(fecha) {
      if(fecha){
        const fechaValida = new Date(fecha.replace(/\.\d{6}Z$/, 'Z'));
        return formatDistanceToNow(fechaValida, { addSuffix: true, locale: es });
      }      
    },
    handleResize() {
      this.chunks = 1;
      if (window.innerWidth >= 560){
        this.chunks = 2;
      }
    },
    onChange() {
      this.validar();
    },
    validar() {
      validar(document.formulario);
      this.enmascararValor();
    },
    enmascararValor() {
    var valor = this.offer_price;
    valor = reemplaza(valor, "$", "");
    valor = reemplaza(valor, ".", "");

    var largo_valor = trim(valor).length;
    var invertido = "";
    var cont = 0;
    for (var g = (largo_valor - 1); g >= 0; g--) {
        var aux = trim(valor).substr(g, 1);
        if (cont == 3) {
            invertido = invertido + '.';
            cont = 0;
        }
        invertido = invertido + aux;
        cont++;
    }// fin For

    var valor_retorno = "";
    var largo = trim(invertido).length;
    var aux3 = "";
    for (var hh = (largo - 1); hh >= 0; hh--) {
        aux3 = trim(invertido).substr(hh, 1);
        valor_retorno = valor_retorno + aux3;
    }// fin For

    var inicio = valor_retorno.substring(0, 1);

    if (valor_retorno.length > 1 && inicio == 0) {
        valor_retorno = valor_retorno.substring(1, valor_retorno.length);
    }

    valor = '$' + valor_retorno;
    this.offer_price = valor;
},
    getOffers: function () {
      fetch("/api/offersPost/" + this.$route.params.slug)
        .then((response) => {
          if (!response.ok) {
            // Si la respuesta no está OK, lanzar un error
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.json();
        })
        .then((json) => {
          // Manejar los datos exitosos aquí
          this.offers = json;
        })
        .catch((error) => {
          // Capturar errores, incluyendo errores 404
          console.error(error);
        })
    },
  },
  data: function () {
    return {
      postSelected: "",
      post: "",
      state: "",
      images: [],
      questions: [],
      id_image: "",
      precio: "",
      zonas_entrega: '',
      ventas_reales: 0,
      nombre_usuario: '',
      nombre_real_usuario: '',
      telefono_usuario: '',
      correo_usuario: '',
      rating_ventas: 0,
      total_califications: 0,
      detalle: [],
      imagesLoaded: false,
      avg: 0,
      colors: '',
      dominio: window.location.origin + '/manual',
      question: '',
      offer: '',
      baseUrl: '',
      isVisible: false,
      textCalification: 'Ver todas las calificaciones',
      scrollPosition: 0,
      isZooming: false,
      showModal: false,
      currentIndex: 0,
      imagesModal: [],
      titulo_otros_usuario: 'Otros productos del vendedor',
      titulo_otros_relacionados: 'Otros productos relacionados',
      tipo_titulos: 'producto',
      atributos: [],
      chunks: 1,
      offer_price: '1',
      offers : [],
    };
  },
};
</script>
<style scoped>
.custom-container inner-image-zoom {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.zoom-image {
  width: 100%;
  height: auto;
  transition: transform 0.2s ease-in-out;
}

.modal-padre {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 100000;
}

.modal-image {
  max-width: 90%;
  max-height: 90%;
}

.close-modal-padre-button {
  position: absolute;
  top: 10px;
  right: 10px;
  background: transparent;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #fff; /* Cambia el color si lo necesitas */
}

.icono-modal-prev {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z'/%3e%3c/svg%3e");
}

.icono-modal-next {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/%3e%3c/svg%3e");
}
</style>